export default __webpack_public_path__ + "static/media/smile-rate-3.11daf548.svg";